import {PackageStatus} from '@sollapay/enums';
import {
  PACKAGE_CLARIFICATION_FIELD,
  SUPPLEMENTARY_REVOKED_CLARIFICATION_FIELD
} from '@sollapay/types';

import type {ClarificationRequest} from '@sollapay/types';

/**
 * The reviewer's note for a package that was sent back: the entry under the reserved package name,
 * else every reason joined so a request that names something else is still shown rather than dropped.
 * Null for any other status — the stored requests are kept after a resubmit as an audit trail.
 */
export function getPackageClarificationNote(pkg: {
  status: PackageStatus;
  clarificationRequests: ClarificationRequest[] | null;
}): string | null {
  const requests = pkg.clarificationRequests;
  if (pkg.status !== PackageStatus.CLARIFICATION_REQUIRED || !requests?.length) return null;

  const general = requests.find(request => request.name === PACKAGE_CLARIFICATION_FIELD);
  const note = general ? general.reason : requests.map(request => request.reason).join('\n');
  return note.trim() || null;
}

const RESERVED_NOTE_KEYS: Record<string, string> = {
  [SUPPLEMENTARY_REVOKED_CLARIFICATION_FIELD]:
    'activation.clarification.reserved.supplementaryRevoked'
};

/**
 * The i18n key for a clarification the system raised itself. Its stored text is English only, so
 * the firm sees the translated copy for that reserved name instead.
 */
export function getReservedClarificationNoteKey(
  requests: ClarificationRequest[] | null
): string | null {
  return requests?.map(request => RESERVED_NOTE_KEYS[request.name]).find(Boolean) ?? null;
}
